<script setup>
</script>

<template>
    <div class="relative">
        <slot></slot>
    </div>
</template>

